package kz.dentalcrm.app.data.network.response_model.services

import kotlinx.serialization.Serializable

@Serializable
data class ServicesResponse(
    val data: List<ServiceItem>? = null
)
